module.exports = __webpack_public_path__ + "img/grade-a.fbe46111.svg";